import { DateTime } from 'luxon';

import {
  useCurrentUser,
  useReferenceListDisplayValue,
  useUserStore,
} from '~/client/hooks/storeHooks';
import { isTempNumericId, tempNumericId } from '~/common/tinybase/utils';
import {
  CaseEventContactMethodCode,
  CaseEventInOrOutCode,
  NewCaseEventPayload,
} from '~/common/types/cases';

export const useCreateCaseEvent = (caseId: number) => {
  const user = useCurrentUser();

  const userStore = useUserStore();
  const referenceListDisplayValue = useReferenceListDisplayValue();

  const createCaseEvent = (
    contactMethodCode: CaseEventContactMethodCode,
    inOrOutCode: CaseEventInOrOutCode,
    note: string,
  ) => {
    if (!user || !userStore) {
      return;
    }
    const now = DateTime.now().toISO();

    const newEventPayload: NewCaseEventPayload = {
      caseId,
      note,
      // Will be overwritten when the event is created in LWP
      eventId: tempNumericId(),
      contactMethod: referenceListDisplayValue('LWP_EVENT', String(contactMethodCode)),
      contactMethodCode,
      inOrOut: referenceListDisplayValue('LWP_COMM', String(inOrOutCode)),
      inOrOutCode,
      createdBy: user.camdenAccountName,
      created: now,
      reportedDate: now,
    };

    userStore.handleAndDispatchMessage('createCaseEvent', caseId, newEventPayload, {
      newEntityTempId: newEventPayload.eventId,
      newEntityParentTempId: isTempNumericId(caseId) ? caseId : undefined,
    });
  };

  return createCaseEvent;
};
